import moment from "moment"

export default function(application) {
  return {
    created: moment(application.created_at),
    paymentMethod: application.payment_method,
    reason: application.reason,
  }
}
